<div class="container-fluid p-0">
    <div class="row">
        <div class="col-xl-7" [ngStyle]="{'background-image': 'url(assets/images/login/2.jpg)',
                                      'background-size': 'cover',
                                      'background-position': 'center center',
                                      'display': 'block'}">
            <img class="bg-img-cover bg-center d-none" src="assets/images/login/2.jpg" alt="looginpage">
        </div>
        <div class="col-xl-5 p-0">
            <router-outlet name="register"></router-outlet>
            <!-- <app-register-step1></app-register-step1> -->
        </div>
    </div>
</div>
